import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { BoardEntity } from 'src/app/models/entities/board.entity';
import { CardEntity } from 'src/app/models/entities/card.entity';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardComponent  implements OnInit {
  @Input()
  public card!: CardEntity;

  @Input()
  public fixedHeight: boolean = false;

  @Input()
  public inColumn: boolean = true;


  @Input()
  public color!: string;

  @Input()
  public textColor!: string;

  @Input()
  public expanded: boolean = false;


  @Input()
  public minify: boolean = false;

  @Input()
  public parts: any = {};

  @Output()
  public clicked: EventEmitter<void> = new EventEmitter<void>();

  userScore: number | null = null;
  showBoardIcon: boolean = true;

  ngOnInit(): void {
    this.userScore = this.getUserScore(this.card);
  }

  onBoardIconError(): void {
    // If board icon fails to load, hide it and show fallback icon
    this.showBoardIcon = false;
  }

  getUserScore(card: CardEntity): number | null {
    if (!card) {
      return null;
    }
  
    const userId = card.assignedTo;
  
    if (!userId) {
      return null;
    }
  
    if (!Array.isArray(card.participants)) {
      return null;
    }
  
    for (const participant of card.participants) {
      if (participant && typeof participant === 'object' && participant.userKey === userId) {
        if (participant.score && typeof participant.score === 'object' && 'seconds' in participant.score) {
          return 0;
        }
        return participant.score;
      }
    }
  
    return null;
  }

  // *ngIf="filtered(item)"

  // [assignedTo]="item.assignedTo"
  // [epic]="item.epic"
  // [enhancements]="item.enhancements"
  // [messageCount]="item.count"
  // [alert]="item.alert"
  // (click)="editItem($event, index, item)"
  // [columnOrder]="item.orderInColumn"
  // [index]="item.index"
  // [textColor]="column.frontcolor"
  // [color]="column.backcolor"
  // [title]="item.name"
  // [type]="item.type"
  // [part]="item.part"
  // [expanded]="column.expanded"

  /** Abbreviate an environment label for the compact card badge ("Quality Assurance" → QA). */
  public envAbbrev(env: string): string {
    const known: Record<string, string> = {
      'production': 'PROD',
      'staging': 'STG',
      'quality assurance': 'QA',
      'development': 'DEV',
      'pre-production': 'PREPROD',
      'preproduction': 'PREPROD',
    };
    const key = (env || '').trim().toLowerCase();
    if (known[key]) return known[key];
    const words = key.split(/\s+/).filter(Boolean);
    // Multi-word → initials; single word → first 4 letters
    return (words.length > 1
      ? words.map((w) => w[0]).join('')
      : key.slice(0, 4)
    ).toUpperCase();
  }
}
